/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineFilter {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineFilter.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineFilter>): AIUnitEconomicsBaselineFilter {
        let obj = Object.assign(new AIUnitEconomicsBaselineFilter(), model);
        AIUnitEconomicsBaselineFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineFilter>): AIUnitEconomicsBaselineFilter {
        if (!model) return null;
        return AIUnitEconomicsBaselineFilter.newInstance(<AIUnitEconomicsBaselineFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineFilter) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineFilter): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Scope the baseline applies to. 'tenant' requires applicable_entity_id; 'master_account' must omit it and applies to the caller's master account
     */
    scope: models.AIUnitEconomicsBaselineScope;

    /**
     * Query operator filter; pass a TenantQueryOperator to narrow by tenant
     */
    filters: models.QueryOperator;

    /**
     * Case-insensitive substring match on the baseline name
     */
    name: string;

    /**
     * Return baselines in effect on or after this date
     */
    start_date: Date;

    /**
     * Return baselines that start before this date (exclusive)
     */
    end_date: Date;

}
